export const printerMachinesColumns = [
  { label: 'Nome da Impressora', value: 'display_name' },
  { label: 'Status', value: 'status' },
  { label: 'Modelo', value: 'part_number' },
  { label: 'N° de Cartões Impressos', value: 'printed_cards_count' },
  { label: 'Ações', value: 'actions', className: 'w-0' },
]
